module.exports = __webpack_public_path__ + "img/jiling.73a79ab1.png";